import { ApiError, fetchWithAuth } from "@entities/user-tokens";

import type { PresignedPost, SlideFormat, SlideFormatOrigin } from "../SlideFormat";

/**
 * 新規スライドフォーマットを register し、presigned POST 情報を取得する。
 *
 * 由来はサーバー既定が `manual`（＝コンソールでの手上げ）なので、**アドインからは常に明示する**。
 * 省略時はライブラリーへ残す `addin`。生成タスク用の使い捨ては呼び出し側が `task` を渡す
 * （`task` は一覧に出ず、タスク削除で連鎖削除される）。
 */
export async function registerSlideFormat(meta: {
    name: string;
    filename: string;
    contentType: string;
    size: number;
    origin?: SlideFormatOrigin;
}): Promise<{ slideFormat: SlideFormat; upload: PresignedPost }> {
    const res = await fetchWithAuth("/slide-formats", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ ...meta, origin: meta.origin ?? "addin" }),
    });
    if (!res.ok) throw await ApiError.fromResponse(res, "スライドフォーマットの登録に失敗しました");
    return (await res.json()) as { slideFormat: SlideFormat; upload: PresignedPost };
}
